(() => {
  if (window.__moduleComboRenderBound) return;
  window.__moduleComboRenderBound = true;

  const SOURCE = '[data-module-combo-source]';
  const SLOT = '[data-module-combo-slot]';

  function isExecutableScript(script) {
    const type = (script.getAttribute('type') || 'text/javascript').trim().toLowerCase();
    return (
      type === '' ||
      type === 'text/javascript' ||
      type === 'application/javascript' ||
      type === 'module'
    );
  }

  function executeScripts(root) {
    root.querySelectorAll('script').forEach((oldScript) => {
      if (!isExecutableScript(oldScript)) return;
      const script = document.createElement('script');
      Array.from(oldScript.attributes).forEach((attr) => {
        script.setAttribute(attr.name, attr.value);
      });
      script.textContent = oldScript.textContent;
      oldScript.replaceWith(script);
    });
  }

  function initAlpine(root) {
    if (!window.Alpine?.initTree) return;
    if (root.matches?.('[x-data]')) window.Alpine.initTree(root);
    root.querySelectorAll('[x-data]').forEach((el) => {
      if (el._x_dataStack) return;
      window.Alpine.initTree(el);
    });
  }

  function matchesLabel(el, label) {
    if (el.nodeType !== 1) return false;
    if (el.hasAttribute('data-module-label-always')) return true;
    if (el.dataset.moduleLabel === label) return true;
    const nested = el.querySelector('[data-module-label], [data-module-label-always]');
    if (!nested) return false;
    if (nested.hasAttribute('data-module-label-always')) return true;
    return nested.dataset.moduleLabel === label;
  }

  function hasModuleLabel(el) {
    if (el.nodeType !== 1) return false;
    return Boolean(el.dataset.moduleLabel || el.querySelector('[data-module-label]'));
  }

  function nodesForLabel(fragment, label) {
    const children = Array.from(fragment.children);
    const nodes = [];

    children.forEach((el, index) => {
      if (!matchesLabel(el, label)) return;
      nodes.push(el);
      for (let i = index + 1; i < children.length; i += 1) {
        const next = children[i];
        if (next.tagName === 'SCRIPT') {
          nodes.push(next);
          continue;
        }
        if (hasModuleLabel(next)) break;
        break;
      }
    });

    return nodes;
  }

  let rendering = false;

  function render(label) {
    if (!label || rendering) return;
    rendering = true;

    try {
      document.querySelectorAll(SOURCE).forEach((tpl) => {
        const slot = tpl.parentElement?.querySelector(SLOT);
        if (!slot) return;

        const matches = nodesForLabel(tpl.content, label);
        slot.replaceChildren(...matches.map((node) => node.cloneNode(true)));
        executeScripts(slot);
        initAlpine(slot);

        const section = slot.closest('.shopify-section, .module-view-section');
        if (!section) return;
        section.dispatchEvent(
          new CustomEvent('shopify:section:load', {
            bubbles: true,
            detail: { sectionId: section.id?.replace(/^shopify-section-/, '') || '' },
          }),
        );
      });
    } finally {
      rendering = false;
    }
  }

  function boot() {
    if (!document.querySelector(SOURCE)) return;
    render(document.documentElement.getAttribute('data-active-module'));
  }

  document.addEventListener('module-label:change', (event) => {
    render(event.detail?.label);
  });

  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:block:select', (event) => {
    const target = event.target;
    const label =
      target?.dataset?.moduleLabel || target?.querySelector?.('[data-module-label]')?.dataset?.moduleLabel;
    if (label) render(label);
  });
  document.addEventListener('alpine:initialized', () => {
    document.querySelectorAll(SLOT).forEach(initAlpine);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
